import { put, call, takeEvery } from "redux-saga/effects";
import * as apis from "../../network/apis/categories";
import * as types from "./types";
import * as actions from "./actions";
import { showErrorMsg, showSuccessMsg } from "../../utils/Helpers";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";
import history from "../../routes/History";

function* getCategoriesListSaga({ payload }) {
  try {
    const response = yield call(apis.getCategoriesList, payload);
    yield put(
      actions.getCategoriesResponse({
        list: response.data.categories,
        meta: {
          currentPage: +response.headers["current-page"],
          count: +response.headers["total-count"],
          pages: +response.headers["total-pages"],
        },
      })
    );
    if (+response.headers["current-page"] > +response.headers["total-pages"]) {
      yield put(
        actions.getCategoriesRequest({
          ...payload,
          page: +response.headers["total-pages"],
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* addCategorySaga({ payload }) {
  try {
    yield call(apis.addCategory, payload);
    yield showSuccessMsg("addedSuccessfully");
    yield history.push(ROUTE_PATHS.serviceProviderCategories);
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* editCategorySaga({ payload }) {
  try {
    yield call(apis.editCategory, payload);
    yield showSuccessMsg("editedSuccessfully");
    yield history.push(
      ROUTE_PATHS.viewServiceProviderCategories.replace(":id", payload.id)
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* patchCategoryToggleSaga({ payload }) {
  try {
    yield call(apis.patchCategoryToggle, payload);
    // Optionally refresh details so UI reflects latest flags
    if (payload.id) {
      const response = yield call(apis.getCategoryDetails, payload.id);
      yield put(
        actions.getCategoryDetailsResponse({
          categoryDetails: response.data.category,
        })
      );
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* getCategorySaga({ payload }) {
  try {
    const response = yield call(apis.getCategoryDetails, payload);
    yield put(
      actions.getCategoryDetailsResponse({
        categoryDetails: response.data.category,
      })
    );
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

function* deleteCategorySaga({ payload }) {
  try {
    yield call(apis.deleteCategory, payload);
    yield showSuccessMsg("deletedSuccessfully");
    if (payload.currentPage) {
      yield put(
        actions.getCategoriesRequest({
          items: 10,
          page: payload.currentPage,
        })
      );
    } else {
      yield history.push(ROUTE_PATHS.serviceProviderCategories);
    }
  } catch (error) {
    yield showErrorMsg(error.response?.data?.message);
  }
}

export default function* CategoriesSagas() {
  yield takeEvery(types.GET_CATEGORIES_REQUEST, getCategoriesListSaga);
  yield takeEvery(types.ADD_CATEGORY_REQUEST, addCategorySaga);
  yield takeEvery(types.GET_CATEGORY_DETAILS_REQUEST, getCategorySaga);
  yield takeEvery(types.EDIT_CATEGORY_REQUEST, editCategorySaga);
  yield takeEvery(types.PATCH_CATEGORY_TOGGLE_REQUEST, patchCategoryToggleSaga);
  yield takeEvery(types.DELETE_CATEGORY_REQUEST, deleteCategorySaga);
}
